export default __webpack_public_path__ + "static/media/credit-card.59909861.svg";